module.exports = __webpack_public_path__ + "assets/img/Spark-Systems-Website.ca0a4029.jpg";